import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../AppContext";
import { hot } from "react-hot-loader";
import UserAvatar from "react-user-avatar";
import { Spin, Select } from "antd";
import { User, ProjectUser } from "../../services/generated-sdk/models";
import { UsersApi, ProjectUsersApi } from "../../services/generated-sdk/apis";
import { formatNmae, handleError } from "../../utils/common";
import TCUserAvatar from "./TCUserAvatar";
import { getAvatarURL } from "../../utils/common-ts";

function UserSelectInput({ selectProps = {}, projectMembers = [], ...props }) {
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState<ProjectUser[]>([]);

  let { projectId } = useContext(AppContext);
  if (!projectId) {
    projectId = props.projectId;
  }
  const api = new UsersApi();

  useEffect(
    () => {
      if (projectMembers && projectMembers.length) {
        setUsers(
          projectMembers.map(usr => {
            if (usr && usr.user && usr.user.id) {
              return usr;
            }
            return { ...usr, user: usr };
          })
        );
      } else {
        if (props.doNotFetchUsers == undefined || !props.doNotFetchUsers) {
          fetchUsers();
        }
      }
    },
    [projectId]
  );

  const fetchUsers = async () => {
    setLoading(true);
    const API = new ProjectUsersApi();
    try {
      let users = [];
      if (projectId) {
        users = await API.getProjectUsers({
          project: projectId,
          filter: JSON.stringify({
            "user.confirmed": true
          })
        });
      }
      setLoading(false);
      setUsers(users);
    } catch (e) {
      console.log(e);
      setLoading(false);
      handleError(e.status);
    }
  };

  if (!projectId) {
    return <span>Project ID not set!</span>;
  }

  if (loading) {
    return <Spin />;
  }
  // console.log({ users });
  return (
    <Select
      mode={"default"}
      style={{ width: "100%" }}
      onChange={props.onChange}
      defaultValue={
        props.value != undefined && props.value ? props.value : null
      }
      {...selectProps}
    >
      {users.map(record => (
        <Select.Option
          key={`user_${record.user.id.toString()}`}
          value={record.user.id}
          //selected={(props.initialValue != undefined && props.initialValue == record.user.id)? true: false}
        >
          <span>
            <UserAvatar
              name={formatNmae(record.user.name)}
              src={
                record.user.avatar
                  ? getAvatarURL(record.user.avatar)
                  : undefined
              }
              id={record.user.id}
              size={28}
            />
            <span style={{ color: "rgba(0, 0, 0, 0.75)", paddingLeft: 5 }}>
              {record.user.name}
            </span>
          </span>
        </Select.Option>
      ))}
    </Select>
  );
}

export default hot(module)(UserSelectInput);
